export const SEARCH_WEIGHT = {
  DEFAULT: 1,
  RESOURCE_NAME: 1,
  RESOURCE_INITIALS: 0.5,
  RESOURCE_ID: 0.1,
  COMMAND_NAME: 1,
  COMMAND_INITIALS: 0.6,
  PHONE_NUMBER: 0.2,
  EMAIL: 0.2,
  SEEN_MRN: 0.2,
  BIRTH_DATE_M_D_YYYY: 0.2,
  BIRTH_DATE_MMMM_D_YYYY: 0.2,
  NICKNAME: 1,
}
